export const COMPANY_ID = 2;